import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { useToast } from '@/hooks/useToast';
import { restUrl } from '@/services/utils';

import type { ItemSelection, PublicationData, PublicationJob } from '../types';
import { getPublicationAngularContext } from './publicationAngularBridge';
import { createSelection } from './usePublishItems';

type SavePublicationJobVariables = {
    itemSelection: ItemSelection;
    publicationData?: PublicationData;
    job: PublicationJob;
};

const useSavePublicationJob = () => {
    const { toast } = useToast();

    return useMutation({
        mutationFn: async ({
            itemSelection,
            publicationData,
            job,
        }: SavePublicationJobVariables) => {
            const selectionId = publicationData?.selectionId
                ?? await createSelection(itemSelection);
            await axios.post(restUrl('jobs'), {
                ...job,
                selectionId,
            });
        },
        onSuccess: () => {
            toast.info('PUBLICATION_STARTED');
        },
        onError: (error) => {
            toast.error(getPublicationAngularContext().getErrorMessage(error, 'PUBLICATION_FAILED'));
        },
    });
};

export { useSavePublicationJob };
export type { SavePublicationJobVariables };
